var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import config from "@/config";
import CorePanel from "@/prefabs/core/Panel";
var LEADERBOARD_SIZE = 7;
var ROW_STRING_FORMAT = "%1  %2";
var PanelLeaderboard = /** @class */ (function (_super) {
    __extends(PanelLeaderboard, _super);
    function PanelLeaderboard(scene, x, y) {
        var _this = _super.call(this, scene, x, y) || this;
        _this.text_group = [];
        for (var i = 0; i < LEADERBOARD_SIZE; i++) {
            _this.createRow(i);
        }
        _this.bg = new Phaser.GameObjects.Image(scene, 0, 0, "background.list-panel").setOrigin(0.5);
        _this.add(_this.bg);
        _this.add(new Phaser.GameObjects.Image(scene, 0, 200, "background.list-panel-my"));
        _this.add(_this.text_group);
        _this.setScale(0.8);
        _this.setDepth(99998);
        _this.setScrollFactor(0);
        // RESIZE
        _this.RESIZE_H_FACTOR = 1;
        _this.RESIZE_H_MAX = _this.bg.height;
        _this.RESIZE_W_FACTOR = 0.25;
        _this.RESIZE_W_MAX = _this.bg.width;
        return _this;
    }
    PanelLeaderboard.prototype.setPosition = function (x, y, z, w) {
        var _a;
        _super.prototype.setPosition.call(this, x + (((_a = this.bg) === null || _a === void 0 ? void 0 : _a.width) / 2) * this.scaleX, y, z, w);
        return this;
    };
    PanelLeaderboard.prototype.createRow = function (index) {
        var x = -110;
        var y = -160 + index * 60;
        var color = index == 0
            ? "#F9D027"
            : index == 1
                ? "#D4D4D4"
                : index == 2
                    ? "#FF7E16"
                    : "#ffffff";
        var default_style = {
            color: color,
            fontSize: "24px",
            fontFamily: config.graphics.fontFamily,
        };
        this.text_group[index * 2] = new Phaser.GameObjects.Text(this.scene, x, y, "", __assign(__assign({}, default_style), { align: "left" })).setOrigin(0, 0.5);
        this.text_group[index * 2 + 1] = new Phaser.GameObjects.Text(this.scene, x + 220, y, "", __assign(__assign({}, default_style), { fontSize: "24px", align: "right" })).setOrigin(1, 0.5);
    };
    PanelLeaderboard.prototype.setCharAt = function (str, index, chr) {
        if (index > str.length - 1)
            return str;
        return str.substring(0, index) + chr + str.substring(index + 1);
    };
    PanelLeaderboard.prototype.setPlayerRow = function (username, score, index) {
        this.text_group[(LEADERBOARD_SIZE - 1) * 2].setText(Phaser.Utils.String.Format(ROW_STRING_FORMAT, [
            ![null, undefined].includes(index) ? index + 1 + "" : "",
            username.substring(0, 7),
        ]));
        this.text_group[(LEADERBOARD_SIZE - 1) * 2 + 1].setText(score + "");
    };
    PanelLeaderboard.prototype.setLeaderboardRow = function (username, score, index) {
        if (index >= LEADERBOARD_SIZE - 1)
            return;
        this.text_group[index * 2].setText(Phaser.Utils.String.Format(ROW_STRING_FORMAT, [
            index + 1 + "",
            username.substring(0, 7),
        ]));
        this.text_group[index * 2 + 1].setText(score + "");
    };
    PanelLeaderboard.prototype.updateRow = function (row, username) {
        if (row.username === username) {
            this.setPlayerRow(row.username, row.score, row.index);
        }
        this.setLeaderboardRow(row.username, row.score, row.index);
    };
    PanelLeaderboard.prototype.update = function (username, leaderboard) {
        var _this = this;
        if (!leaderboard[Symbol.iterator]) {
            this.updateRow(leaderboard, username);
            return;
        }
        leaderboard.forEach(function (e, index) {
            _this.updateRow(__assign(__assign({}, e), { index: index }), username);
        });
    };
    PanelLeaderboard.prototype.updateLocal = function (username, score) {
        username = username.substring(0, 7);
        for (var i = 0; i < LEADERBOARD_SIZE - 1; i++) {
            if (this.text_group[i * 2].text.includes(username)) {
                this.text_group[i * 2 + 1].text = score + "";
            }
        }
        for (var i = 0; i < LEADERBOARD_SIZE - 1; i++) {
            for (var j = i + 1; j < LEADERBOARD_SIZE - 1; j++) {
                if (parseInt(this.text_group[i * 2 + 1].text) <
                    parseInt(this.text_group[j * 2 + 1].text)) {
                    var temp = this.text_group[i * 2].text;
                    this.text_group[i * 2].text = this.text_group[j * 2].text;
                    this.text_group[j * 2].text = temp;
                    var tempScore = this.text_group[i * 2 + 1].text;
                    this.text_group[i * 2 + 1].text = this.text_group[j * 2 + 1].text;
                    this.text_group[j * 2 + 1].text = tempScore;
                }
            }
        }
        for (var i = 0; i < LEADERBOARD_SIZE - 1; i++) {
            this.text_group[i * 2].text = this.setCharAt(this.text_group[i * 2].text, 0, i + 1 + "");
        }
        this.setPlayerRow(username, score, null);
    };
    return PanelLeaderboard;
}(CorePanel));
export default PanelLeaderboard;
